/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import CustomerOnboardingVideo from "../../CustomerOnboardingVideo";
import ChangePassword from "./ChangePassword";
import DriverLicense from "./DriverLicense";
import Success from "./Success";
import questionsData from "../../../utilites/questionnaireData.json";
import { useSelector } from "react-redux";
import OnboardingQuestionnaire from "./OnboardingQuestionnaire";
import OnBoardingBookAppointment from "./OnBoardingBookAppointment";
import OnboardingVerification from "./OnboardingVerification";
import SendMessageOnboarding from "./SendMessageOnboarding";
import { useDispatch } from "react-redux";
import allActions from "../../../Store/action";
import StartingStep from "./StartingStep";
import TaxCallChecklist from "./TaxCallChecklist";

const MultyStepOnboading = ({ setEnableCloseWelcomeModal }) => {
  const dispatch = useDispatch()
  const [user] = useSelector((state) => [
    state.user,
    state.dashboard,
  ]);
  const [questions, setQuestions] = useState(questionsData);
  const totalSteps = 7;
  const [answers, setAnswers] = useState();
  const [step, setStep] = useState(
    localStorage?.getItem("onboarding_step")
      ? Number(localStorage?.getItem("onboarding_step"))
      : 0
  );
  const [questionSteps, setQuestionSteps] = useState(1);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const modalEl = document.getElementById("showonboardingVideoModal");

    const handleModalShow = () => {
      const storedStep = localStorage.getItem("onboarding_step");
      if (storedStep && Number(storedStep) !== step) {
        setStep(Number(storedStep));
      }
    };

    if (modalEl) {
      modalEl.addEventListener("shown.bs.modal", handleModalShow);
    }

    return () => {
      if (modalEl) {
        modalEl.removeEventListener("shown.bs.modal", handleModalShow);
      }
    };
  }, [step]);

const handleNext = (byTwo = false, skip = false) => {
  const answeredQuestions = user.LoginData?.assessment?.content || {};
  const findNextUnansweredIndex = (startIndex) => {
    for (let i = startIndex; i < questions.length; i++) {
      const qId = questions[i].id?.toString();
      const answerArr = answeredQuestions[qId];

      const isAnswered =
        Array.isArray(answerArr) &&
        answerArr.some((a) => a?.toString().trim() !== '');

      if (!isAnswered) return i;
    }
    return -1; 
  };

  const currentIndex = questions.findIndex((q) => q.id === currentQuestion);

  const goToNext = () => {
    const nextUnansweredIndex = findNextUnansweredIndex(currentIndex + 1);

    if (nextUnansweredIndex !== -1) {
      setCurrentQuestion(questions[nextUnansweredIndex].id);
      setQuestionSteps((prev) =>
        prev < totalSteps ? prev + (byTwo ? 2 : 1) : prev
      );
    } else {
     
     if (!user?.LoginData?.settings?.firstMessageSent) {
        setStep((prev) => prev + 1);
      }else  if(user?.LoginData?.settings?.firstMessageSent && !user?.LoginData?.settings?.isPdfDownloaded) {
        setStep((prev) => prev + 2);
      } else if(user?.LoginData?.settings?.firstMessageSent && user?.LoginData?.settings?.isPdfDownloaded) {
        setStep((prev) => prev + 3);
      }
    }
  };

  if (!skip) {
    setLoading(true);
    dispatch(
      allActions.dashboard.answerQuestion(
        user.LoginData?.lead[0],
        user.LoginData?.lead[0]?.userpro.id,
        answeredQuestions,
        currentQuestion,
        questions.find((q) => q.id === currentQuestion)?.selectedAnswers,
        questions.length
      )
    ).then(() => {
      setLoading(false);
      goToNext();
    });
  } else {
    goToNext();
  }
};


  const handleAnswer = (question, answer, type) => {
    const questionID = question?.id;
    if (type === "checkbox") {
      if (question?.selectedAnswers?.includes(answer?.toString())) {
        setQuestions(
          (questions || []).map((q) => {
            if (q?.id === questionID) {
              return {
                ...q,
                selectedAnswers: q?.selectedAnswers?.filter(
                  (a) => a !== answer?.toString()
                ),
              };
            }
            return q;
          })
        );
      } else {
        setQuestions(
          (questions || []).map((q) => {
            if (q?.id === questionID) {
              return {
                ...q,
                selectedAnswers: [
                  ...(q?.selectedAnswers || []),
                  answer?.toString(),
                ],
              };
            }
            return q;
          })
        );
      }
    } else if (type === "radio") {
      if (question?.selectedAnswers?.includes(answer?.toString())) {
        setQuestions(
          (questions || []).map((q) => {
            if (q?.id === questionID) {
              return {
                ...q,
                selectedAnswers: q?.selectedAnswers?.filter(
                  (a) => a !== answer?.toString()
                ),
              };
            }
            return q;
          })
        );
      } else {
        setQuestions(
          (questions || []).map((q) => {
            if (q?.id === questionID) {
              return {
                ...q,
                selectedAnswers: [answer?.toString()],
              };
            }
            return q;
          })
        );
      }
    }
  };

  // The flag is written to the logged-in user's own settings, but the lead's
  // nested copy can lag behind it. Accept either so the step stays checked.
  const isPdfDownloaded =
    !!user?.LoginData?.settings?.isPdfDownloaded ||
    !!user?.LoginData?.lead?.[0]?.user?.settings?.isPdfDownloaded;

  let assessmentContent = user?.LoginData?.assessment?.content;

  const questionnaireState = {
    min: 0,
    max: questions.length,
    value:
      user?.LoginData?.assessment !== null
        ? Object?.keys(assessmentContent).length
        : 0,
  };

useEffect(() => {
  localStorage.setItem("onboarding_step", step);

  // ✅ only-video-left detector (based on real completion flags)
  const isVideoWatched = !!user?.LoginData?.settings?.isOnboardingVideoSeen;

  // Use BOTH spellings because your codebase uses both in different places
  const isPasswordChanged =
    !!user?.LoginData?.settings?.isPasswordChanged ||
    !!user?.loginData?.settings?.isPasswordChanged;

  const isVerified = !!user?.LoginData?.isVerify;

  const hasLicense = !!user?.LoginData?.lead?.[0]?.driver_license;

  const isQuestionnaireCompleted =
    questionnaireState?.value === questionnaireState?.max;

  const isMessageSent = !!user?.LoginData?.settings?.firstMessageSent;

  const allowAppointments =
    !!user?.LoginData?.lead?.[0]?.userpro?.user?.settings?.allow_appointments;

  const isAppointmentBooked =
    !allowAppointments || !!user?.LoginData?.settings?.appointment_scheduled;

  // checklist step exists at step 8 in your flow

  const allOtherStepsCompleted =
    isPasswordChanged &&
    isVerified &&
    hasLicense &&
    isQuestionnaireCompleted &&
    isMessageSent &&
    isPdfDownloaded &&
    isAppointmentBooked 

  // ✅ FIX: if only video left -> allow closing
  if (allOtherStepsCompleted && !isVideoWatched) {
    setEnableCloseWelcomeModal(true);
    return;
  }

  // ✅ keep your original logic unchanged
  if ((step > 2 || user?.LoginData?.settings?.isOnboardingVideoSeen) && step !== 2) {
    setEnableCloseWelcomeModal(true);
  } else {
    setEnableCloseWelcomeModal(false);
  }
}, [step]);


  function StepDots({ totalSteps = 6, currentStep = 1 }) {
  return (
    <div className="d-flex justify-content-center align-items-center gap-2 mt-2">
      {[...Array(totalSteps)].map((_, idx) => {
        const isActive = idx + 1 === currentStep;

        return (
          <div
            key={idx}
            className={`rounded-pill`}
            style={{
              width: isActive ? "10px" : "7px",
              height: "7px",
              backgroundColor: isActive ? "#4F46E5" : "#cbd5e1", 
              transition: "all 0.3s ease",
            }}
          />
        );
      })}
    </div>
  );
}


  return (
    <div>
      <div
        className="container pb-2 d-flex align-items-center justify-content-center"
        style={{ gap: "20px" }}
      >
      {step !== 8 && step !== 0 &&
        <div>
          <div className="text-center">
            Step {step} of {9}
          </div>
          <StepDots totalSteps={9} currentStep={step} />
        </div>
      }
      </div>
    {user?.LoginData?.lead[0]?.userpro?.uuid && 
    <>
      {step === 0 && 
      <StartingStep 
      setStep={setStep}
      user={user}
       isVideoWatched={user?.LoginData?.settings?.isOnboardingVideoSeen} 
          isAppointmentBooked={user?.LoginData?.settings?.appointment_scheduled}
          license={user?.LoginData?.lead[0]?.driver_license}
          questionnaireState={questionnaireState}
          isVerify={user?.LoginData?.isVerify}
          taxpro_allow_appointments={
            user?.LoginData?.lead[0]?.userpro?.user?.settings?.allow_appointments
          }
          isMessageSent={user?.LoginData?.settings?.firstMessageSent}
          isPdfDownloaded={isPdfDownloaded}
       />}
      {step === 1 &&
       <CustomerOnboardingVideo setStep={setStep} 
          isAppointmentBooked={user?.LoginData?.settings?.appointment_scheduled}
          license={user?.LoginData?.lead[0]?.driver_license}
          questionnaireState={questionnaireState}
          isVerify={user?.LoginData?.isVerify}
          taxpro_allow_appointments={
            user?.LoginData?.lead[0]?.userpro?.user?.settings?.allow_appointments
          }
          isMessageSent={user?.LoginData?.settings?.firstMessageSent}
          isPdfDownloaded={isPdfDownloaded}
      />}
      {step === 2 && (
        <ChangePassword
          setStep={setStep}
          data={user?.LoginData}
          user={user}
          isAppointmentBooked={user?.LoginData?.settings?.appointment_scheduled}
          license={user?.LoginData?.lead[0]?.driver_license}
          questionnaireState={questionnaireState}
          isVerify={user?.LoginData?.isVerify}
          taxpro_allow_appointments={
            user?.LoginData.lead[0]?.userpro.user.settings?.allow_appointments
          }
          isMessageSent={user?.LoginData?.settings?.firstMessageSent}
          isPdfDownloaded={isPdfDownloaded}
        />
      )}
      {step === 3 && (
        <OnboardingVerification
          user={user?.LoginData}
          setStep={setStep}
          isAppointmentBooked={user?.LoginData?.settings?.appointment_scheduled}
          isQuestionnaireCompleted={
            questionnaireState?.value === questionnaireState?.max
          }
          isVerify={user?.LoginData?.isVerify}
          license={user?.LoginData?.lead[0]?.driver_license}
          taxpro_allow_appointments={
            user?.LoginData.lead[0]?.userpro.user.settings?.allow_appointments
          }
          isMessageSent={user?.LoginData?.settings?.firstMessageSent}
          isPdfDownloaded={isPdfDownloaded}
        />
      )}
      {step === 4 && (
        <OnBoardingBookAppointment
          user={user}
          setStep={setStep}
          setUserProAvatar={{}}
          step={step}
          license={user?.LoginData?.lead[0]?.driver_license}
          isQuestionnaireCompleted={
            questionnaireState?.value === questionnaireState?.max
          }
          isMessageSent={user?.LoginData?.settings?.firstMessageSent}
          isPdfDownloaded={isPdfDownloaded}
        />
      )}
      {step === 5 && (
        <DriverLicense
          setStep={setStep}
          questions={questions}
          assessment={user?.LoginData?.assessment}
          userId={user?.LoginData?.id}
          license={user?.LoginData?.lead[0]?.driver_license}
          userFullname={
            user?.LoginData?.firstname + " " + user?.LoginData?.lastname
          }
          isQuestionnaireCompleted={
            questionnaireState?.value === questionnaireState?.max
          }
          isMessageSent={user?.LoginData?.settings?.firstMessageSent}
          isAppointmentBooked={user?.LoginData?.settings?.appointment_scheduled}
          isVerify={user?.LoginData?.isVerify}
          isVideoWatched={user?.LoginData?.settings?.isOnboardingVideoSeen} 
          isPasswordChanged={user?.loginData?.settings?.isPasswordChanged}
          isPdfDownloaded={isPdfDownloaded}
        />
      )}
      {step === 6 && (
        <OnboardingQuestionnaire
          currentQuestion={currentQuestion}
          setCurrentQuestion={setCurrentQuestion}
          handleNext={handleNext}
          handleAnswer={handleAnswer}
          questions={questions}
          answers={answers}
          setAnswers={setAnswers}
          step={questionSteps}
          setStep={setQuestionSteps}
          setQuestions={setQuestions}
          isMessageSent={user?.LoginData?.settings?.firstMessageSent}
          lead={user?.LoginData.lead[0]}
          user={user?.LoginData}
          loading={loading}
        />
      )}
      {step === 7 && (
        <SendMessageOnboarding 
          user={user?.LoginData}
          userpro={user?.LoginData.lead[0]?.userpro}
          setStep={setStep}
          isPdfDownloaded={isPdfDownloaded}
          questionnaireState={questionnaireState}
          license={user?.LoginData?.lead[0]?.driver_license}
          taxpro_allow_appointments={
            user?.LoginData.lead[0]?.userpro.user.settings?.allow_appointments
          }
          isAppointmentBooked={user?.LoginData?.settings?.appointment_scheduled}
          isVerify={user?.LoginData?.isVerify}
        />
      )}

         {step === 8 && (
        <TaxCallChecklist 
          user={user?.LoginData}
          userpro={user?.LoginData.lead[0]?.userpro}
          setStep={setStep}
          isPdfDownloaded={isPdfDownloaded}
          questionnaireState={questionnaireState}
          license={user?.LoginData?.lead[0]?.driver_license}
          taxpro_allow_appointments={
            user?.LoginData.lead[0]?.userpro.user.settings?.allow_appointments
          }
          isAppointmentBooked={user?.LoginData?.settings?.appointment_scheduled}
          isVerify={user?.LoginData?.isVerify}
        />
      )}
      {step === 9 && (
        <Success
          setStep={setStep}
          user={user?.LoginData}
          answers={answers}
          questions={questions}
          questionnaireState={questionnaireState}
          isAppointmentBooked={!user?.LoginData.lead[0].userpro.user.settings?.allow_appointments || user?.LoginData?.settings?.appointment_scheduled}
          isVerify={user?.LoginData?.isVerify}
          license={user?.LoginData?.lead[0]?.driver_license}
          isPasswordChanged={user?.loginData?.settings?.isPasswordChanged}
          isMessageSent={user?.LoginData?.settings?.firstMessageSent}
             taxpro_allow_appointments={
            user?.LoginData.lead[0]?.userpro.user.settings?.allow_appointments
          }
          isPdfDownloaded={isPdfDownloaded}
        />
      )}</>
    }
    </div>
  );
};

export default MultyStepOnboading;
